import UnitSearchList from "components/common/dl_unit/UnitSearchList/UnitSearchList";
import { useParams } from "react-router-dom";

export default function GroupUTypeUnits() {
  const { slug, uType } = useParams();

  if (!slug || !uType) {
    return <></>;
  }

  return (
    <div>
      <UnitSearchList navigateToSearch />
    </div>
  );
}
